module.exports = __webpack_public_path__ + "static/media/square-root-alt.c6bca3db.svg";